import { createContext, useContext, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'

const DistributionFatigueContext = createContext()

const today = new Date()
const currentYear = today.getFullYear()
const currentMonth = today.getMonth()
const startDate = new Date(currentYear, currentMonth, 1)

export const DistributionFatigueProvider = ({ children }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingFilters, setLoadingFilters] = useState(true)
  const [dateRange, setDateRange] = useState([startDate, new Date()])
  const [filterOptions, setFilterOptions] = useState(null)
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [graphMessage, setGraphMessage] = useState(null)
  const [labels, setLabels] = useState([])

  const onSelectFilter = value => {
    setSelectedUser(null)
    setInputValue('')
    setSelectedFilterOptions(value)
  }

  const onSelectUser = value => {
    setSelectedUser(value)
    setInputValue(value.name)
    setSelectedFilterOptions([])
  }

  const fetchData = async () => {
    if (!loading) setLoading(true)

    try {
      const { data } = await RequestService.getDistributionFatigue({
        date: dateRange,
        selectedFilterOptions,
        selectedUserId: selectedUser?.id,
      })

      setData(data.data)
      setLabels(data.labels)
      setGraphMessage(data.graphMessage)
    } catch (error) {
      console.error('Error on data fetch', error)
    }

    setLoading(false)
  }

  const getPossibleFilters = async () => {
    if (!loadingFilters) setLoadingFilters(true)

    try {
      const { data } = await RequestService.getDistributionFatigueFilters()

      setFilterOptions(data)
    } catch (error) {
      console.error('Error on data fetch filters', error)
    }

    setLoadingFilters(false)
  }

  useEffect(() => {
    fetchData()
  }, [dateRange, selectedFilterOptions, selectedUser?.id])

  useEffect(() => {
    getPossibleFilters()
  }, [])

  return (
    <DistributionFatigueContext.Provider
      value={{
        data,
        loading,
        dateRange,
        onDateRangeChange: setDateRange,
        loadingFilters,
        filterOptions,
        onSelectFilter,
        selectedFilterOptions,
        selectedUser,
        onSelectUser,
        inputValue,
        onInputValueChange: setInputValue,
        graphMessage,
        labels,
      }}
    >
      {children}
    </DistributionFatigueContext.Provider>
  )
}

export const useDistributionFatigue = () => {
  return useContext(DistributionFatigueContext)
}
